import React from "react";
import { Navigate } from "react-router-dom";
import DoctorBiopsyList from "../doctor/DoctorBiopsyList";
import LabBiopsyList from "../lab/LabBiopsyList";
import PathologistBiopsyList from "../pathologist/PathologistBiopsyList";
import AdminBiopsyList from "../admin/AdminBiopsyList";
import TeachingAdminBiopsyList from "../teaching-admin/TeachingAdminBiopsyList";

export default function BiopsyListDispatcher() {
  const userType = (localStorage.getItem("userType") || "").toLowerCase().trim();
  if (userType === "doctor")         return <DoctorBiopsyList />;
  if (userType === "lab technician") return <LabBiopsyList />;
  if (userType === "pathologist")    return <PathologistBiopsyList />;
  if (userType === "admin")          return <AdminBiopsyList />;
  if (userType === "teaching admin") return <TeachingAdminBiopsyList />;
  return <Navigate to="/" replace />;
}
